<template>
  <window-portal :open="show" @close="onClose">
    <preview-document :config="previewConfig">
      <template #pages="{ config }">
        <!-- pages -->
        <preview-page
          v-for="(pageData, pIndex) in pagesData"
          :key="`page-${pIndex}`"
          :config="config"
        >
          <!-- page header -->
          <template #header>
            <div
              style="
                display: flex;
                justify-content: space-between;
                font-size: 8pt;
              "
            >
              <div>Impreso: {{ fechaHora }}</div>
              <div>NIT: 
                <b>
                  {{ data.header.BusinessBillingNIT }}
                </b>
              </div>
            </div>
            <div style="text-align: center; font-size: 10pt; text-transform: uppercase;">
              <div>
                <b>
                  {{ data.header.BusinessBillingName }}
                </b>
              </div>
              <div>
                <b>
                  KARDEX DE INVENTARIOS
                </b>
              </div>
              <div>
                <b>{{ data.header.warehouse }}</b><br>
                <b>
                  {{ data.header.item.ItemComercialName }} ({{ data.header.item.ItemName }})
                </b>
              </div>
              <div>
                Del {{ data.header.dataStarFilter }} al
                {{ data.header.dataEndFilter }}
              </div>
              
            </div>
          </template>
          <!-- body -->
          <div style="margin-top: 10px">
            <table id="kardex-complete-tb"
              style="width: 100%; font-size: 8pt; border-collapse: collapse;"
            >
              <thead>
                <tr style="text-align: center">
                  <th rowspan="2" style="padding: 6px 2px; border: 1px solid #bdbdbd;">ITEM</th>
                  <th rowspan="2" style="padding: 6px 2px; border: 1px solid #bdbdbd;">FECHA</th>
                  <th rowspan="2" style="padding: 6px 2px; border: 1px solid #bdbdbd;">TIPO</th>
                  <th rowspan="2" style="padding: 6px 2px; border: 1px solid #bdbdbd;">DOCUMENTO</th>
                  <th rowspan="2" style="padding: 6px 2px; border: 1px solid #bdbdbd;">DETALLE</th>
                  <th colspan="3" style="border: 1px solid #bdbdbd; color: #2c3e50; padding: 3px 2px;">ENTRADAS</th>
                  <th colspan="3" style="border: 1px solid #bdbdbd; color: #2c3e50; padding: 3px 2px;">SALIDAS</th>
                  <th colspan="3" style="border: 1px solid #bdbdbd; color: #2c3e50; padding: 3px 2px;">SALDOS</th>
                </tr>
                <tr style="border: none; text-align: center">
                  <th style="border: 1px solid #bdbdbd; padding: 4px;">CANT.</th>
                  <th style="border: 1px solid #bdbdbd; padding: 4px;">C. UNIT.</th>
                  <th style="border: 1px solid #bdbdbd; padding: 4px;">C. TOTAL</th>
                  <th style="border: 1px solid #bdbdbd; padding: 4px;">CANT.</th>
                  <th style="border: 1px solid #bdbdbd; padding: 4px;">UNIT.</th>
                  <th style="border: 1px solid #bdbdbd; padding: 4px;">TOTAL</th>
                  <th style="border: 1px solid #bdbdbd; padding: 4px;">CANT.</th>
                  <th style="border: 1px solid #bdbdbd; padding: 4px;">C. UNIT.</th>
                  <th style="border: 1px solid #bdbdbd; padding: 4px;">TOTAL</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(row, rIndex) in pageData"
                  :key="`row-${pIndex}-${rIndex}`"
                  style="vertical-align: top; text-align: left"
                >
                  <td style="padding: 2px">{{ rIndex + 1 }}</td>
                  <td style="padding: 2px;">{{ row.fecha }}</td>
                  <td style="padding: 2px;font-size: 7pt;">{{ row.tipo }}</td>
                  <td style="padding: 2px">
                    {{ row.documento }}
                  </td>
                  <td 
                  style="
                      padding: 2px; 
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      max-width: 220px;
                      text-align: left;
                      "
                      >{{ row.ProviderCustomer }}</td>
                  <td style="padding: 2px">{{ row.cantidad_compra }}</td>
                  <td style="text-align: right; padding: 2px">
                    <span v-if="row.cantidad_compra">
                      {{ row.precio_compra | formattedDollar }}
                    </span>
                  </td>
                  <td style="padding: 2px; text-align: right">
                    <span v-if="row.cantidad_compra">
                      {{ row.total_compra | formattedDollar }}
                    </span>
                  </td>
                  <td style="text-align: right; padding: 2px">{{ row.cantidad_venta  }}</td>
                  <td style="padding: 2px; text-align: right">
                    <span v-if="row.cantidad_venta">
                      {{ row.precio_venta | formattedDollar}}
                    </span>
                  </td>
                  <td style="text-align: right; padding: 2px">
                    <span v-if="row.cantidad_venta">
                      {{ row.total_venta | formattedDollar }}
                    </span>
                  </td>
                  <td style="text-align: right; padding: 2px">{{ row.saldo_cantidad }}</td>
                  <td style="text-align: right; padding: 2px">
                      {{ row.costo_promedio | formattedDollar }}
                  </td>
                  <td style="text-align: right; padding: 2px">
                      {{ row.saldo_valor | formattedDollar }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <template #footer>
            <div
              style="
                border-top: 1px solid black;
                font-size: 8pt;
                text-align: right;
              "
            >
              {{ pIndex + 1 }} / {{ totalPages }}
            </div>
          </template>
        </preview-page>
      </template>
    </preview-document>
  </window-portal>
</template>
<style scoped>
  #kardex-complete-tb {
    width: 100%;
    border-collapse: collapse;
    
  }
  th, td {
    padding: 4px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  td.multiline {
    white-space: normal;
    text-overflow: initial;
  }
</style>
<script>
import WindowPortal from "@/components/ReportsAndPrintings/WindowPortal.vue";
import PreviewDocument from "@/components/PreviewDocument/PreviewDocument.vue";
import PreviewPage from "@/components/PreviewDocument/PreviewPage.vue";

export default {
  name: "PrintKardexDetails",

  model: {
    event: "update",
    prop: "show",
  },

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    show: {
      type: Boolean,
      default: false,
    },
  },

  components: { WindowPortal, PreviewDocument, PreviewPage },

  data: () => ({
    previewConfig: {
      title: "Vista Previa de Impresión Kardex del Producto",
      filename: `KardexDetallado.pdf`,
      margins: [10, 10, 10, 10],
      unit: "mm",
      format: "letter",
      orientation: "landscape",
    },
    pagesData: [[]],
    maxRowsPerPage: 35,
    fechaHora: (new Date()).toLocaleString('es-SV', {
      weekday: 'short',      
      year: 'numeric',
      month: 'short',
      day: '2-digit',   
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    })
  }),
  computed: {
    totalPages() {
      return this.pagesData.length;
    },
  },
  methods: {
    onClose() {
      this.$emit("update", false);
    },
    getCurrentPage(nextRecords = 1) {
      const page = this.pagesData[this.pagesData.length - 1];
      if (page.length + nextRecords <= this.maxRowsPerPage) {
        return page;
      } else {
        this.pagesData.push([]);
        return this.pagesData[this.pagesData.length - 1];
      }
    },
    paginateData() {
      this.pagesData = [[]];
      for (const item of this.data.data) {
        const page = this.getCurrentPage();
        page.push(item);
      }
      console.log("1111", this.$clone(this.pagesData));
    },
  },
  watch: {
    show(value) {
      if (value) {
        this.paginateData();
      }
    },
  },
  filters: {
    formattedDollar(value) {
      if (value === null || value === undefined || value === '' || isNaN(value)) {
        return '$0.00';
      }
      const numValue = parseFloat(value);
      const formatted = numValue.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return `$${formatted}`;
    }
  }
};
</script>